import React from 'react'
import BankCardLineIcon from 'remixicon-react/BankCardLineIcon'

import type {VirtualCard} from 'src/api/rest'
import {theme} from 'src/themes'
import {InfoCard} from '../account'
import {P} from '../typography'

interface Props {
  cardInfo?: VirtualCard
  selected?: boolean
  onSelect: () => void
  onDelete?: () => void
}

export default function CreditCardInfo({
  cardInfo,
  selected,
  onSelect,
  onDelete,
}: Props): JSX.Element {
  return (
    <InfoCard
      icon={<BankCardLineIcon size={30} color={theme.palette.primary} />}
      selected={selected}
      onSelect={onSelect}
      deleteIcon
      title=""
      description={
        <>
          <P>
            {cardInfo?.brand} - {cardInfo?.maskedCardNumber?.slice(-4)}
          </P>
          <P>
            Gildistími {cardInfo?.expMonth}/{cardInfo?.expYear}
          </P>
        </>
      }
      cornerButton
      handleDelete={onDelete}
      pointerCursor
    />
  )
}
